import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperPayment: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    cardWrapper: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      gap: "32px",
    },
    containerSections: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      gap: "24px",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
      },
    },
    containerLeftSide: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      alignItems: "center",
      [theme.breakpoints.down(321)]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    containerHeader: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    containerMainTitle: {
      fontSize: "30px",
      fontWeight: 600,
      lineHeight: "38px",
      color: theme.palette.text.primary,
    },
  };
});
